// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/switch/switch.scss
// module id = 533
// module chunks = 0